import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppContext } from "../contexts/AppContext";
import { updateProfile, getuserInfo } from "../store/actions/userActions";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "./const.prop";

const AddExperience = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  const [experienceType, setExperienceType] = useState("");
  const [experienceInfo, setExperienceInfo] = useState([
    {
      companyName: "",
      position: "",
      experience: "",
    },
  ]);
  const [error, setError] = useState(false);
  const [userError, setUserError] = useState(false);

  useEffect(() => {
    if (
      userData &&
      userData?.userExperiances &&
      userData?.userExperiances?.length > 0
    ) {
      const experience = userData?.userExperiances.map((item) => {
        return {
          companyName: item?.company_name || "",
          position: item?.position || "",
          experience: item?.experiance || "",
        };
      });
      setExperienceInfo([...experience]);
    }
  }, [userData]);

  const handleExperienceInfoChange = (e, index) => {
    const { name, value } = e.target;
    let tempObj = { ...experienceInfo[index] };
    tempObj = { ...tempObj, [name]: value };
    let tempArray = [...experienceInfo];
    tempArray.splice(index, 1, tempObj);
    setExperienceInfo(tempArray);
  };

  const handleExperiences = (option, index) => {
    setError(false);
    let tempArray = [...experienceInfo];
    if (option === "add") {
      if (tempArray.length > 0) {
        tempArray.push({
          companyName: "",
          position: "",
          experience: "",
        });
        setExperienceInfo(tempArray);
      }
    }
    if (option === "remove") {
      if (tempArray.length > 1 && index) {
        tempArray.splice(index, 1);
        setExperienceInfo(tempArray);
      }
    }
  };

  const successCallback = () => {
    dispatch(getuserInfo());
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const formValidation = () => {
    let isValid = true;

    for (let i = 0; i < experienceInfo.length; i++) {
      const item = experienceInfo[i];

      if (!experienceType) {
        if (!item.companyName || !item.position || !item.experience) {
          isValid = false;
          break;
        }
      } else if (experienceType === "professional") {
        if (!item.companyName || !item.position || !item.experience) {
          isValid = false;
          break;
        }
      } else if (experienceType === "others") {
        if (!item.experience) {
          isValid = false;
          break;
        }
      }
    }
    return isValid;
  };

  const handleSubmit = () => {
    if (!experienceType) {
      setUserError(true);
      return false;
    } else if (formValidation()) {
      dispatch(
        updateProfile(
          {
            experience: experienceInfo,
            experienceType: experienceType,
          },
          successCallback,
          failureCallback
        )
      );
    }
    if (!formValidation()) {
      setError(true);
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Please fill the required fields",
      });
    }
  };

  return (
    <div>
      <div
        className="modal-body"
        style={{ maxHeight: "26rem", overflow: "hidden auto" }}
      >
        <div>
          <label>Experience type</label>
          <select
            className="form-select mb-3 w-100"
            onChange={(e) => {
              setExperienceType(e.target.value);
              setUserError(false);
            }}
            value={experienceType}
          >
            <option value="">Please select</option>
            <option value="professional">Working Professional</option>
            <option value="others">Others</option>
          </select>
          {userError && !experienceType && (
            <p className="field-error">User type is required</p>
          )}
        </div>
        {experienceInfo &&
          experienceInfo?.length > 0 &&
          experienceInfo.map(({ companyName, position, experience }, index) => (
            <>
              <div className="row mt-4">
                <div className="col-md-12">
                  <div className="form-group input-group">
                    <label className="has-float-label">
                      <input
                        className="form-control py-4"
                        type="text"
                        name="companyName"
                        value={companyName || ""}
                        onChange={(e) => handleExperienceInfoChange(e, index)}
                        disabled={
                          !experienceType || experienceType === "others"
                        }
                      />
                      <span>Company</span>
                    </label>
                  </div>
                  {error &&
                    !companyName &&
                    experienceType === "professional" && (
                      <p className="field-error">Company name is missing</p>
                    )}
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  <div className="form-group input-group">
                    <label className="has-float-label">
                      <input
                        className="form-control py-4"
                        type="text"
                        name="position"
                        value={position || ""}
                        onChange={(e) => handleExperienceInfoChange(e, index)}
                        disabled={
                          !experienceType || experienceType === "others"
                        }
                      />
                      <span>Position</span>
                    </label>
                  </div>
                  {error && !position && experienceType === "Professional" && (
                    <p className="field-error">Position is missing</p>
                  )}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-8">
                  <div className="form-group input-group">
                    <label className="has-float-label">
                      <input
                        className="form-control py-4 "
                        type="text"
                        name="experience"
                        value={experience || ""}
                        onChange={(e) => handleExperienceInfoChange(e, index)}
                        disabled={!experienceType}
                      />
                      <span>Experience</span>
                    </label>
                  </div>
                  {error && !experience && (
                    <p className="field-error">Experience is missing</p>
                  )}
                </div>
                <div className="col-md-2">
                  <div
                    className="rounded  cursor-pointer p-2 add-input mt-1 mr-2"
                    style={{ border: "1px solid #D9D4DA" }}
                    onClick={() => handleExperiences("add")}
                  >
                    <span className="ml-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.0122 0.791748C15.8835 0.791748 17.8128 2.80733 17.8128 5.80696V12.7974C17.8128 15.797 15.8835 17.8126 13.0122 17.8126H5.59266C2.72128 17.8126 0.791992 15.797 0.791992 12.7974V5.80696C0.791992 2.80733 2.72128 0.791748 5.59266 0.791748H13.0122ZM13.0122 1.97925H5.59266C3.39816 1.97925 1.97949 3.48104 1.97949 5.80696V12.7974C1.97949 15.1233 3.39816 16.6251 5.59266 16.6251H13.0122C15.2075 16.6251 16.6253 15.1233 16.6253 12.7974V5.80696C16.6253 3.48104 15.2075 1.97925 13.0122 1.97925ZM9.30241 5.80086C9.63016 5.80086 9.89616 6.06686 9.89616 6.39461V8.7005L12.2051 8.70066C12.5328 8.70066 12.7988 8.96666 12.7988 9.29441C12.7988 9.62216 12.5328 9.88816 12.2051 9.88816L9.89616 9.888V12.1952C9.89616 12.5229 9.63016 12.7889 9.30241 12.7889C8.97466 12.7889 8.70866 12.5229 8.70866 12.1952V9.888L6.39976 9.88816C6.07122 9.88816 5.80601 9.62216 5.80601 9.29441C5.80601 8.96666 6.07122 8.70066 6.39976 8.70066L8.70866 8.7005V6.39461C8.70866 6.06686 8.97466 5.80086 9.30241 5.80086Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                {index > 0 && (
                  <span
                    onClick={() => handleExperiences("remove", index)}
                    className="cursor-pointer mt-2 ml-3"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                    >
                      <path
                        d="M16.0028 6.7332C16.3959 6.7662 16.6885 7.11919 16.6563 7.52219C16.6514 7.58919 16.1218 14.3141 15.8165 17.135C15.6292 18.875 14.5066 19.932 12.8154 19.963C11.5299 19.987 11.2187 20 9.93225 20C9.68841 20 9.44555 20 9.20172 19.999C8.80768 19.997 8.48874 19.669 8.49068 19.264C8.49166 18.861 8.8106 18.536 9.20464 18.536L9.56709 18.5369C10.0237 18.5376 10.3902 18.5363 10.7387 18.5332L11.2569 18.5272C11.6925 18.5211 12.1563 18.5123 12.789 18.501C13.7634 18.482 14.2891 17.983 14.3974 16.975C14.7007 14.1741 15.2294 7.47119 15.2342 7.40419C15.2654 7.00119 15.6146 6.7122 16.0028 6.7332ZM2.01947 6.7329C2.41253 6.7149 2.75683 7.00189 2.78804 7.40489C2.79292 7.47189 3.31765 14.1568 3.62391 16.9797C3.73022 17.9667 4.24911 18.4767 5.16593 18.4967C5.55997 18.5047 5.87306 18.8397 5.86525 19.2437C5.85648 19.6427 5.53851 19.9597 5.1513 19.9597H5.13667C3.51174 19.9247 2.38912 18.8457 2.20478 17.1427C1.89657 14.2968 1.37086 7.58889 1.36599 7.52089C1.3338 7.11889 1.6264 6.7659 2.01947 6.7329ZM11.0795 0C11.967 0 12.7473 0.613991 12.9775 1.49398C13.0799 1.88497 12.8536 2.28597 12.4732 2.39096C12.0938 2.49596 11.7017 2.26397 11.5993 1.87297C11.5359 1.63198 11.3223 1.46398 11.0795 1.46398H6.94301C6.70015 1.46398 6.48655 1.63198 6.42315 1.87297L6.1959 3.04595C6.16468 3.20395 6.11592 3.35195 6.0574 3.49695H17.2973C17.6913 3.49695 18.0112 3.82394 18.0112 4.22794C18.0112 4.63293 17.6913 4.95993 17.2973 4.95993H0.724208C0.330168 4.95993 0.0112305 4.63293 0.0112305 4.22794C0.0112305 3.82394 0.330168 3.49695 0.724208 3.49695H3.91846C4.34371 3.49695 4.71337 3.18595 4.79628 2.75996L5.03426 1.53998C5.27517 0.613991 6.05545 0 6.94301 0H11.0795Z"
                        fill="#FF0000"
                      />
                    </svg>
                  </span>
                )}
              </div>
            </>
          ))}
      </div>
      <div className="modal-footer mt-2 mb-3 d-flex">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default AddExperience;
